<template lang="html">
  <b-modal
      :id="modalId"
      no-close-on-backdrop
      size="xl"
      @shown="init()"
      @hidden="hideModal"
  >
    <template v-slot:modal-header>
      <div>
        <h5 class="modal-title">{{ modalTitle }}</h5>
        <div>{{ modalSubtitle }}</div>
      </div>
    </template>

    <name-input
        :all-des="allDes"
        :is-ready="!loadingData"
        :should-focus="!de.name"
        :name="de.name"
        :de-id="de.id"
        @on-name-input-changed="onDeNameChanged"
    ></name-input>

    <element-description
        v-if="!loadingData"
        :elem-description="de.description"
        @on-element-description-changed="onDeDescriptionChanged"
    ></element-description>

    <div class="crm-fields-container">
      <label class="query-label">
        {{ $t("fields") }}
      </label>
      <search-box
          v-if="true"
          :multi-select="true"
          :has-icon="true"
          :box-type="'deEditModal'"
          :list="fieldsForMultiSelect"
          :values="storedDataElement.selectedFields"
          @on-search-box-item-selected="onSearchBoxItemSelected"
      />
    </div>

    <transition name="loader">
      <div class="loader-wrapper" v-if="loadingData">
        <div class="loader"></div>
      </div>
    </transition>

    <template v-slot:modal-footer>
      <button
          class="modal-btn no-user-select modal-cancel-btn"
          @click="hideModal()"
      >
        {{ getMessageText(messages.CANCEL) }}
      </button>
      <button
          class="modal-btn no-user-select modal-save-btn"
          :disabled="isDisabled"
          @click="finishQuery()"
      >
        {{ getMessageText(messages.OK) }}
      </button>
    </template>
  </b-modal>
</template>

<script lang="js">
import {mapActions, mapGetters, mapState} from "vuex";
import {MUTATION_NAME} from "@/static/global-variables";
import utils from "@/utils";
import store from "@/store";
import SearchBox from "@/components/SearchBox.vue";
import NameInput from "@/components/NameInput.vue";
import ElementDescription from "@/components/ElementDescription.vue";
import services from "@/services";

export default {
  name: "FeedbackAccountChannelGoalsEditModal",
  components: {
    ElementDescription,
    NameInput,
    SearchBox
  },
  props: {
    appId: String,
    de: Object,
    id: String,
    name: String,
    allDes: Object
  },
  data() {
    return {
      storedDataElement: {
        deName: null,
        deDescription: null,
        dataElement: null,
        desClone: null,
        selectedFields: [],
      },
      loadingData: false,
      fields: [],
      isNameValid: false
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapState({
      messages: "messages"
    }),
    modalId() {
      return "feedback-account-channel-goals-edit-modal_" + this.de.id;
    },
    isDisabled() {
      return !(this.storedDataElement.selectedFields.length > 0) || !this.isNameValid;
    },
    hasData() {
      return Boolean(this.dataElement && this.desClone);
    },
    modalTitle() {
      return `${this.getMessageText(this.messages.Edit)} ${this.$t(
          utils.getDataElementLabel(this.de.type)
      )}`;
    },
    modalSubtitle() {
      return utils.getModalSubtitle(this.de.type);
    },
    fieldsForMultiSelect() {
      return this.fields;
    }
  },
  methods: {
    ...mapGetters([
    ]),
    ...mapActions({
      setDataElement: MUTATION_NAME.SET_EDIT_DATA_ELEMENT
    }),
    hideModal() {
      if (this.de.notReady) {
        const params = {
          appId: this.de.appId,
          deId: this.de.id
        };
        store.commit(MUTATION_NAME.DELETE_DATA_ELEMENT, params);
      }
      this.dataElement = null;
      this.desClone = null;
      this.$emit("de-modal-closed");
      this.$bvModal.hide(this.modalId);
    },
    finishQuery() {
      const deInfo = {
        appId: this.appId,
        de: {
          id: this.de.id,
          description: this.deDescription,
          name: this.deName,
          isNameValid: this.isNameValid,
          type: this.de.type,
          selectedFields: this.storedDataElement.selectedFields
        },
        fields: []
      };
      store.commit(MUTATION_NAME.UPDATE_DE_QUERY, deInfo);
      this.$bvModal.hide(this.modalId);
    },
    init() {
      if (this.de.name) {
        this.deName = this.de.name;
        this.isNameValid = this.de.isNameValid;
      }
      this.deDescription = this.de.description;
      this.storedDataElement.selectedFields = this.de.selectedFields ? this.de.selectedFields : [];
      if (this.fields.length === 0) {
        this.describeFeedbackData();
      }

      this.loadingData = false;

      this.dataElement = JSON.parse(JSON.stringify(this.de));
      this.desClone = JSON.parse(JSON.stringify(this.allDes));
    },
    describeFeedbackData() {
      this.loadingData = true;
      services.getFeedbackMetadata().then(res => {
        let goalFields = services.filterObjectFields(res.properties.accountData.items.properties.goalDetails.items.properties);
        services.updateChannelIDLabel(goalFields);
        this.fields = services.fieldNameToTitleCaseLabel(goalFields);
      }, () => {
        this.fields = [];
      }).finally(() => {
        this.loadingData = false;
      });
    },
    onDeNameChanged(isValidName, nameInput) {
      this.deName = nameInput;
      this.isNameValid = isValidName;
    },
    onDeDescriptionChanged(input) {
      this.deDescription = input;
    },
    onSearchBoxItemSelected(fields) {
      this.storedDataElement.selectedFields = fields;
      this.setDataElement(this.storedDataElement);
    }
  }
};
</script>
